import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Chemical Weapon"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-chemical-weapon',
    templateUrl: './icon-chemical-weapon.component.html',
    styleUrls: ['./icon-chemical-weapon.component.scss'],
    standalone: false
})
export class IconChemicalWeaponComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
